import React from 'react';
import AssetOptions from '../../AssetOptions/AssetOptions';
import MultipleAgreements from '../../MultipleAgreements/MultipleAgreements';
import AssetSizes from '../../AssetSizes/AssetSizes';
import MiniDownloadHistory from '../../MiniDownloadHistory/MiniDownloadHistory';

const SubscriptionDownloadForm: React.FC = () => (
  <div data-testid="subscription-download-form">
    <AssetOptions />
    <MultipleAgreements />
    <AssetSizes />
    <MiniDownloadHistory />
  </div>
);

export default SubscriptionDownloadForm;
